import { Injectable } from '@angular/core';
import { ContractType } from './lib/contract.interfaces';
import { Staff } from '../staff/staff.model';
import {
  ContractTypeEligibility,
  EligibilityFn,
} from './lib/eligibility.interfaces';
import { Observable } from 'rxjs';
import { VolunteerEligibility } from './eligibility/volunteer.eligibility.be';
import { StudentJobEligibility } from './eligibility/student-job.eligibility.be';
import { SideJobEligibility } from './eligibility/side-job.eligibility.be';
import {
  MonitorNonStudentEligibility,
  MonitorStudentEligibility,
} from './eligibility/monitor.eligibility.be';
import { NoContractEligibility } from './eligibility/no-contract.eligibility.be';

@Injectable({ providedIn: 'root' })
export class EligibilityService {
  private readonly handlers: { [k in ContractType]: EligibilityFn } = {
    [ContractType.GeenContract]: NoContractEligibility(),
    [ContractType.Vrijwilliger]: VolunteerEligibility(),
    [ContractType.Bijklusser]: SideJobEligibility(),
    [ContractType.Studentenjob]: StudentJobEligibility(),
    [ContractType.MonitorNietStudent]: MonitorNonStudentEligibility(),
    [ContractType.Monitor]: MonitorStudentEligibility(),
  };

  checkEligibility(
    staff: Staff,
    contractType: ContractType,
  ): Observable<ContractTypeEligibility> {
    return this.handlers[contractType](staff);
  }
}
